import { CSSResultGroup, TemplateResult, html } from 'lit';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { customElement, property } from 'lit/decorators.js';
import componentStyles from './ghs-wrapper.css.lit';
import { classMap } from 'lit/directives/class-map.js';

export const BgVariants: string[] = [
  'neutral-white',
  'primary-blue',
  'primary-green',
  'neutral-gray-5',
  'gradient-blue',
  'gradient-green',
  'bh-brand-primary-default',
  'bh-neutral-white',
];

export type BgVariantType = (typeof BgVariants)[number];
/**
 * The GhsWrapper component
 * @element ghs-wrapper
 * @slot - default slot
 */
@customElement('ghs-wrapper')
export class GhsWrapper extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  /**
   * Document property here
   */
  @property({ type: String, attribute: 'bg-color-variant', reflect: true })
  bgColorVariant: BgVariantType = 'neutral-white';

  protected getClasses() {
    return {
      wrapper: true,
      [`outline-bg--${this.bgColorVariant}`]: this.bgColorVariant,
    };
  }

  render(): TemplateResult {
    const classes = this.getClasses();

    return html`
      <div class="${classMap(classes)}">
        <slot></slot>
      </div>
    `;
  }
}
